export enum UserDocumentType {
  DOCUMENT = 'DOCUMENT',
  BES_ATTACHMENT = 'BES-ATTACHMENT',
  SPORT_ATTACHMENT = 'SPORT-ATTACHMENT',
  CERTIFICATE = 'CERTIFICATE',
  PHOTO_RELEASE_FORM = 'PHOTO-RELEASE-FORM',
}
